import { createRef } from 'react';
import type { RefObject } from 'react';

// Shared reference to the main prompt textarea so non-component modules
// (e.g. utils) can focus it. Kept in its own module so PromptInput.tsx can
// stay a component-only Fast Refresh boundary.
export const textareaRef: RefObject<HTMLTextAreaElement> = createRef<HTMLTextAreaElement>();
